<template>
  <PModal
    class="no-close-modal"
    :backdrop-attrs="{ class: 'z-20!' }"
    title="Choisir le périphérique de signature"
    :model-value="scws.chooseReaderModalProps.open"
    persistent
    @open="model = -1"
  >
    <ul class="flex flex-col gap-2 no-close-modal">
      <li v-for="(reader, $index) in scws.readers" :key="reader.name">
        <button
          class="p-2 border w-full text-left rounded-md flex gap-1 items-center transition-[all] duration-200 ease-out"
          :class="{
            'bg-blue-france-sun-113 text-white': $index === model,
            'hover:bg-blue-france-sun-113-hover hover:text-white': true,
          }"
          @click="model = $index"
        >
          <OhVueIcon :name="$index === model ? checked : checkbox"></OhVueIcon>
          <span class="pb-1v" v-if="reader.name !== '\\SOFTREADER'">{{ reader.name }} </span>
          <span class="pb-1v" v-else>Certificat IGC</span>
        </button>
      </li>
    </ul>
    <template #actions>
      <div class="flex gap-2 justify-end -mr-2">
        <PButton mode="secondary" @click="cancel()"> Annuler </PButton>
        <PButton @click="choose()"> Choisir </PButton>
      </div>
    </template>
  </PModal>
</template>

<script setup lang="ts">
import { PButton, PModal, useIcons } from "@pasta/box-v2";
import { useSCWS } from "../composable/useSCWS";
import { ref } from "vue";
import { OhVueIcon } from "oh-vue-icons";
import { RiCheckboxBlankCircleLine, RiCheckboxCircleFill } from "oh-vue-icons/icons";
import { NoReaderChosenError } from "../errors/scws.error";

const [checkbox, checked] = useIcons(RiCheckboxBlankCircleLine, RiCheckboxCircleFill);

const model = ref(-1);

function cancel() {
  scws.chooseReaderModalProps.open = false;
  scws.chooseReaderModalDeferred.reject(new NoReaderChosenError());
}

function choose() {
  if (model.value === -1) {
    return;
  }
  scws.chooseReaderModalProps.open = false;
  scws.chooseReaderModalDeferred.resolve(model.value);
}

const scws = useSCWS();
</script>
